/**
 * valumize API for managing funds
 * Lorem ipsum ...
 *
 * The version of the OpenAPI document: 0.0.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AiSetupSection = 'COMPANY_DESCRIPTION' | 'END_MARKETS' | 'SWOT' | 'GENERAL_INFO' | 'COMPARABLE_COMPANIES';

export const AiSetupSection = {
    CompanyDescription: 'COMPANY_DESCRIPTION' as AiSetupSection,
    EndMarkets: 'END_MARKETS' as AiSetupSection,
    Swot: 'SWOT' as AiSetupSection,
    GeneralInfo: 'GENERAL_INFO' as AiSetupSection,
    ComparableCompanies: 'COMPARABLE_COMPANIES' as AiSetupSection
};

